import createRoute          from '@widesk-ui/tools/createRoute';
import MessageTemplateModel from '@models/shop/MessageTemplateModel';

export default createRoute.splitView('/message_templates', 'shop', 'MessageTemplateSplitView', MessageTemplateModel.localize('plural'));
